import {
  FieldTypeAsset,
  TextComponentBackground,
  TextComponentPostion,
} from '@allesauto/utils/consts';
import React, { FC } from 'react';

import {
  ITextComponents,
  SectionAreaBase,
  SectionAreaWithBody,
  SectionAreaWithHtml,
  TextComponentLeftProps,
} from './';
import { TestimonialProps } from '../testimonial';

type FlattenedTextComponent = ITextComponents & {
  leftAreaBody?: string;
  isHeaderH1?: boolean;
  leftAreaImage?: FieldTypeAsset;
  sectionArea?: SectionAreaBase[];
  testimonialComponent?: TestimonialProps[];
  position?: TextComponentPostion;
  background?: TextComponentBackground;
  type?: string;
  handleAction?: () => void;
};

/**
 * Adapter that converts a 2-dim text component model into a 3-dim TextComponent model
 *
 * @example
 * {
 *   component: "text-component",
 *   leftAreaBody: {},
 *   sectionArea: [],
 *   testimonialComponent: [],
 *   ...
 * }
 *
 * becomes =>
 *
 * {
 *   component: "text-component",
 *   textComponents: [{
 *     leftAreaBody: {},
 *     sectionArea: [],
 *     testimonialComponent: [],
 *     ...
 *   }]
 * }
 */
export const TextComponentAdapter = (
  TextComponent: FC<FlattenedTextComponent>
) => {
  return function textComponentAdapter(props: FlattenedTextComponent) {
    if (!props.textComponents) {
      const adaptedProps = {
        ...props,
        textComponents: [
          {
            leftArea: {
              body: props.leftAreaBody,
              isHeaderH1: props.isHeaderH1,
              type: props.type,
              image: props.leftAreaImage,
            } as TextComponentLeftProps,
            sectionArea: props.sectionArea?.filter(
              (item) => item.component === 'text-component-section'
            ) as SectionAreaWithBody | SectionAreaWithHtml[],
            testimonialComponent: {
              position: props.position,
              testimonial: props.testimonialComponent?.[0] as TestimonialProps,
            },
          },
        ],
      };

      delete adaptedProps.leftAreaBody;
      delete adaptedProps.sectionArea;
      delete adaptedProps.testimonialComponent;

      return <TextComponent {...(adaptedProps as ITextComponents)} />;
    } else {
      // Fallback to 'old' static JSON structure
      return <TextComponent {...props} />;
    }
  };
};
